import useSearch from '@eGroupTeam/hooks/useSearch';
import { useLocation } from 'react-router';

export default function useLocationSearch() {
  const location = useLocation();
  const search = useSearch(location.search);
  return search;
}
